import Icon from '../components/Icon.vue'

Icon.register({
  'clipboard-list': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M336 64c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-288c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h80c0-35.3 28.7-64 64-64s64 28.7 64 64h80zM96 424c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zM96 328c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zM96 232c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zM192 40c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM320 408v-16c0-4.4-3.6-8-8-8h-144c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8zM320 312v-16c0-4.4-3.6-8-8-8h-144c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8zM320 216v-16c0-4.4-3.6-8-8-8h-144c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/clipboard-list.js
// module id = 1203
// module chunks = 0